import React from 'react';
import { Box, Typography } from '@mui/material';
import VideoPlayer from '../Video/VideoPlayer';

const VideoPlayerSection = ({
  videoId,
  title,
  onPlayerStateChange,
  playerRef,
  isMobile = false
}) => {
  return (
    <>
      <Box sx={{ 
        mb: 2, 
        aspectRatio: '16/9', 
        borderRadius: isMobile ? 0 : 1, 
        overflow: 'hidden', 
        boxShadow: '0 0 20px rgba(0,0,0,0.05)', 
        background: '#000' 
      }}>
        <VideoPlayer
          videoId={videoId}
          onPlayerStateChange={onPlayerStateChange}
          playerRef={playerRef}
        />
      </Box>
      
      {title && (
        <Typography
          variant="subtitle1"
          sx={{ 
            mb: 2, 
            color: '#333', 
            fontWeight: 500, 
            px: 1,
            flexShrink: 0
          }}
        >
          {title}
        </Typography>
      )}
    </>
  );
};

export default VideoPlayerSection; 